import React from 'react'
import YouTube from 'react-youtube'

const Video = ({
  videoId,
  videoOpts,
  videoUrl,
  videoBackgroundImage,
  nodeLocale,
  className,
}) => {
  if (nodeLocale === 'zh-cn') {
    return (
      <video
        controls
        width="100%"
        className={className}
        poster={videoBackgroundImage && videoBackgroundImage.file.url}
      >
        <source src={videoUrl} type="video/mp4" />
      </video>
    )
  }
  return <YouTube videoId={videoId} opts={videoOpts} className={className} />
}

export default Video
